// extracted by mini-css-extract-plugin
export var messageSideLeft = "_sy-1";
export var stateContainer = "_sy-0";